import { Component, OnInit, ChangeDetectorRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { EmploymentFormService } from './services/employment-form.service';
import { HecResponse } from '../../shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { CommonHelper } from '../../../utilities/common.helper';
import { NgForm, Validators } from '@angular/forms';
import { decrypt, encrypt } from '../../../utilities/utilityFunctions';
import { LoaderService } from '../../sharedServices/loader.service';
// import { count } from 'console';

@Component({
	selector: 'kt-employment-form',
	templateUrl: './employment-form.component.html',
	styleUrls: ['./employment-form.component.scss']
})
export class EmploymentFormComponent implements OnInit {
	// public educationDetailsData:any;
	@ViewChild('educationDetailsForm', { static: false }) educationDetailsForm: NgForm;
	public loader: boolean = false;
	public todayDate = new Date();
	public selectedCountry: number;
	public selectedQualification: number;
	public qualId: any;
	public countryId: any;
	public instituteId: any;
	public gradingId: any;
	public qualificationLevel: any = [];
	public universityId: any;
	public totalMarksGpaPlaceHolder: string = 'Enter Obtained CGPA';
	public totalMarksGpaDisplayName: string = 'Obtained CGPA';
	public qualificationCode: any;
	public programId: any;
	public departmentId: any
	public campusId: any;
	public degreeTypeId: any;
	public isAlertVisible: boolean = false;
	public alertClass: string;
	public alertIcon: string;
	public startDate: any;
	public endDate: any;
	public futureDate: Date = new Date(Date.now() + (3600 * 1000 * 24 * 7 * 30 * 365));
	public alertMsgValue: string;
	public isEduAlertVisible: boolean = false;
	public maxGpaValue: number = 0;
	public isEducationInComplete: boolean = false;
	public isCurrentlyEnrolled: boolean = false;
	public isMarksCorrect: boolean = false;
	public greaterThanOrEqualErrorMessage: string;
	public loggedInUserFullName: any;
	public isResearchWork: string = 'false';
	@Output() startDateUpdated = new EventEmitter();
	@Output() endDateUpdated = new EventEmitter();
	@Output() empUpdated = new EventEmitter();
	@Output() cancelEducation = new EventEmitter();
	public dateOfBirth: any;
	public currentDate: any;
	@Input('formViewType') formViewType: any;
	@Input('isDesStream') isDesStream: boolean;
	@Input('desId') desId: any;
	public step = 0;
	@Input('educationDetailsData') educationDetailsData: any;
	@Input('dropdownList') dropdownList: any;
	public equalToErrorMessage;
	@Input('formType') formType: string;
	public isAnyEducationCurrentlyEnrolled: boolean = false;
	public currentlyEnrolledEducationName: string;
	@Input('educationDetailGridData') educationDetailGridData;
	@Input('empFormDropdowns') empFormDropdowns;

	constructor(private educationDetailsService: EmploymentFormService,
		private loaderService: LoaderService,
		private cdr: ChangeDetectorRef, private sharedServices: SharedService) {
		let data = decrypt(localStorage.getItem('esp-profile-details'));
		data = JSON.parse(data);
		this.loggedInUserFullName = data['fullName'];

	}

	async ngOnInit() {
		if (this.educationDetailsData.current) {
			this.educationDetailsData.endData = null;
		}
		console.log(this.empFormDropdowns)

		this.dateOfBirth = new Date(+decrypt(localStorage.getItem(('dob'))));
		this.currentDate = new Date(Date.now());

		for (let i = 0; i < this.educationDetailGridData.length; i++) {
			if (this.educationDetailGridData[i].current && this.educationDetailGridData[i].employmentId != this.educationDetailsData.employmentId) {
				this.currentlyEnrolledEducationName = this.educationDetailGridData[i].designation
				this.isAnyEducationCurrentlyEnrolled = true;
			}
		}
		this.dropdownList.gpaList = [{ label: '4.0', value: 4 }, { label: '5.0', value: 5 }];
		this.openEducationDetails(this.educationDetailsData, this.formViewType);

	}
	ngAfterViewInit(): void {

	}

	public getUniversityListByCountryForAboveHSC(countryId) {
		return new Promise((resolve, reject) => {
			if (countryId != undefined) {
				this.educationDetailsService.getUniversityListByCountryForAboveHSC(countryId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeInstituteList = res.data;
							resolve(this.dropdownList.degreeInstituteList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityListByCountryForBelowHSC(countryId, qualificationId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (countryId != undefined) {
				this.educationDetailsService.getUniversityListByCountryForBelowHSC(countryId, qualificationId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeInstituteListByBoard = res.data;
							resolve(this.dropdownList.degreeInstituteListByBoard);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityDegreeProgramForNonHSCorSSC(universityId, qualificationId) {
		return new Promise((resolve, reject) => {
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityDegreeProgramForNonHSCorSSC(universityId, qualificationId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeProgramList = res.data;
							resolve(this.dropdownList.degreeProgramList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getDicsiplineListByQualId(qualificationId) {
		this.dropdownList.disciplineList = []
		return new Promise((resolve, reject) => {
			if (qualificationId != undefined) {
				if (qualificationId == 7) {
					this.dropdownList.disciplineList = [{ "label": "Arts", "value": 11926 }, { "label": "Commerce", "value": 11927 }, { "label": "Science", "value": 11928 }, { "label": "Technical", "value": 11929 }, { "label": "O-level", "value": 11930 }];
				}
				this.educationDetailsService.getDicsiplineListByQualId(qualificationId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.disciplineList = res.data;
							resolve(this.dropdownList.disciplineList);
							this.cdr.detectChanges();
							this.cdr.markForCheck();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getDegreeProdgramListHSCorSSC(universityId, qualificationId) {
		return new Promise((resolve, reject) => {
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityDegreeProgramListForHSCorSSC(universityId, qualificationId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeProgramList = res.data;
							resolve(this.dropdownList.degreeProgramList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityNameOnDegree(universityId) {
		return new Promise((resolve, reject) => {
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityChangeNames(universityId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.universityNameList = res.data;
							resolve(this.dropdownList.universityNameList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getDataFromUniversityDegreeProgram(programId) {
		this.programId = programId
		this.getUniversityCampuses(this.qualId, this.instituteId, programId);
	}

	public getDataFromUniversityCampus(campusId) {
		this.campusId = campusId
		this.getUniversityDepartments(this.qualId, this.instituteId, this.programId, campusId);
	}

	public getDataFromUniversityDepartment(departmentId) {
		this.departmentId = departmentId;
		this.getUniversityDegreeTypes(this.qualId, this.instituteId, this.programId, this.campusId, departmentId);
	}

	public getDataFromUniversityDegreeType(degreeTypeId) {
		this.degreeTypeId = degreeTypeId;
		if (this.countryId == 1) {
			this.getUniversitySessionsList(this.qualId, this.instituteId, this.programId, this.campusId, this.departmentId, degreeTypeId);
		}
	}

	public getUniversityCampuses(qualificationId, universityId, universityDegreeProgramId) {
		return new Promise((resolve, reject) => {
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityCampus(qualificationId, universityId, universityDegreeProgramId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.campusList = res.data;
							resolve(this.dropdownList.campusList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityDepartments(qualificationId, universityId, universityDegreeProgramId, campusId) {
		return new Promise((resolve, reject) => {
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityDepartments(qualificationId, universityId, universityDegreeProgramId, campusId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.departmentList = res.data;
							resolve(this.dropdownList.departmentList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityDegreeTypes(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId) {
		return new Promise((resolve, reject) => {
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityDegreeType(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeTypesList = res.data;
							resolve(this.dropdownList.degreeTypesList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversitySessionsList(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId, degreeTypeId) {
		return new Promise((resolve, reject) => {
			if (universityId != undefined) {
				this.educationDetailsService.getUniversitySessions(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId, degreeTypeId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.sessionTypesList = res.data;
							resolve(this.dropdownList.sessionTypesList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getEducationMajorList(disciplineId) {
		return new Promise((resolve, reject) => {
			if (disciplineId != undefined) {
				this.educationDetailsService.getEducationMajorList(disciplineId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.majorList = res.data;
							resolve(this.dropdownList.majorList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getCitiesByCountry(countryId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (countryId != undefined) {
				this.sharedServices.getCitiesByCountryId(countryId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.cityList = res.data;
							resolve(this.dropdownList.cityList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public async openEducationDetails(data, type) {
		this.formViewType = type;
		this.educationDetailsData = data;
		if (this.educationDetailsData.bpsEquivalent) this.educationDetailsData.bpsEquivalent = +this.educationDetailsData.bpsEquivalent;
		if (this.educationDetailsData.categoryCodeId) await this.getUniversityListByCountryAndSector(this.educationDetailsData.categoryCodeId);
		if (this.educationDetailsData.employmentCountryId) await this.getCitiesByCountry(this.educationDetailsData.employmentCountryId);

		if (this.educationDetailsData.employerTypeCode == HEC_CONSTANTS.EMP_ORGANIZATION_TYPE.Professional) {
			this.educationDetailsData.employerId = this.educationDetailsData.organizationId;
		}
		else {
			this.educationDetailsData.employerId = this.educationDetailsData.universityId;
		}

		this.loader = false;
		this.loaderService.setValue(this.loader)
		this.cdr.markForCheck();
		this.cdr.detectChanges();

	}

	public async getSelectedInstitutId(instituteId, type?) {
		this.instituteId = instituteId
		if (type) {
			this.dropdownList.campusList = [];
			this.dropdownList.degreeProgramList = [];

			if (this.educationDetailsForm.form.controls.campusId)
				this.educationDetailsForm.form.controls.campusId.reset();
			if (this.educationDetailsForm.form.controls.otherCampus)
				this.educationDetailsForm.form.controls.otherCampus.reset();
			if (this.educationDetailsForm.form.controls.universityDepartmentId)
				this.educationDetailsForm.form.controls.universityDepartmentId.reset();
			if (this.educationDetailsForm.form.controls.otherDepartmentName)
				this.educationDetailsForm.form.controls.otherDepartmentName.reset();
			if (this.educationDetailsForm.form.controls.degreeTypeId)
				this.educationDetailsForm.form.controls.degreeTypeId.reset();
			if (this.educationDetailsForm.form.controls.sessionTypeId)
				this.educationDetailsForm.form.controls.sessionTypeId.reset();
			if (this.educationDetailsForm.form.controls.specializationSubjectId)
				this.educationDetailsForm.form.controls.specializationSubjectId.reset();
			if (this.educationDetailsForm.form.controls.isResearchWork)
				this.educationDetailsForm.form.controls.isResearchWork.reset();
			if (this.educationDetailsForm.form.controls.isFcpsDegree)
				this.educationDetailsForm.form.controls.isFcpsDegree.reset();
		}
		if ((this.qualId != 7 && this.qualId != 8) && this.countryId == 1) {
			await this.getUniversityDegreeProgramForNonHSCorSSC(this.instituteId, this.qualId)
		} else {
			await this.getDegreeProdgramListHSCorSSC(this.instituteId, this.qualId);
		}
		await this.getUniversityNameOnDegree(instituteId);

	}

	public getSelectedQualificationLevel(qualId, type?) {
		if (type == 'update') {
			this.dropdownList.campusList = [];
			this.dropdownList.degreeInstituteList = [];
			this.dropdownList.degreeProgramList = [];
			this.dropdownList.disciplineList = [];
			this.dropdownList.universityNameList = []
			this.educationDetailsForm.form.controls.countryId.reset();
			if (this.educationDetailsForm.form.controls.cityId) {
				this.educationDetailsForm.form.controls.cityId.reset();
			}
			if (this.educationDetailsForm.form.controls.universityId)
				this.educationDetailsForm.form.controls.universityId.reset();
			if (this.educationDetailsForm.form.controls.schoolCollegeDepartmentName)
				this.educationDetailsForm.form.controls.schoolCollegeDepartmentName.reset();
			if (this.educationDetailsForm.form.controls.sectorCode)
				this.educationDetailsForm.form.controls.sectorCode.reset();
			if (this.educationDetailsForm.form.controls.universityDegreeProgramId)
				this.educationDetailsForm.form.controls.universityDegreeProgramId.reset();
			if (this.educationDetailsForm.form.controls.otherProgramTitle)
				this.educationDetailsForm.form.controls.otherProgramTitle.reset();
			if (this.educationDetailsForm.form.controls.subjectId)
				this.educationDetailsForm.form.controls.subjectId.reset();
			if (this.educationDetailsForm.form.controls.otherUniversity)
				this.educationDetailsForm.form.controls.otherUniversity.reset();
			if (this.educationDetailsForm.form.controls.universityNameOnDegreeId)
				this.educationDetailsForm.form.controls.universityNameOnDegreeId.reset();
			if (this.educationDetailsForm.form.controls.campusId)
				this.educationDetailsForm.form.controls.campusId.reset();
			if (this.educationDetailsForm.form.controls.otherCampus)
				this.educationDetailsForm.form.controls.otherCampus.reset();
			if (this.educationDetailsForm.form.controls.universityDepartmentId)
				this.educationDetailsForm.form.controls.universityDepartmentId.reset();
			if (this.educationDetailsForm.form.controls.otherDepartmentName)
				this.educationDetailsForm.form.controls.otherDepartmentName.reset();
			if (this.educationDetailsForm.form.controls.degreeTypeId)
				this.educationDetailsForm.form.controls.degreeTypeId.reset();
			if (this.educationDetailsForm.form.controls.sessionTypeId)
				this.educationDetailsForm.form.controls.sessionTypeId.reset();
			if (this.educationDetailsForm.form.controls.specializationSubjectId)
				this.educationDetailsForm.form.controls.specializationSubjectId.reset();
			if (this.educationDetailsForm.form.controls.isResearchWork)
				this.educationDetailsForm.form.controls.isResearchWork.reset();
			if (this.educationDetailsForm.form.controls.areaResearch)
				this.educationDetailsForm.form.controls.areaResearch.reset();
			if (this.educationDetailsForm.form.controls.gradingSystemCodeId)
				this.educationDetailsForm.form.controls.gradingSystemCodeId.reset();
			if (this.educationDetailsForm.form.controls.registrationNumber)
				this.educationDetailsForm.form.controls.registrationNumber.reset();
			if (this.educationDetailsForm.form.controls.examSystemTypeCode)
				this.educationDetailsForm.form.controls.examSystemTypeCode.reset();
			if (this.educationDetailsForm.form.controls.totalCGPAMarks)
				this.educationDetailsForm.form.controls.totalCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedCGPAMarks)
				this.educationDetailsForm.form.controls.obtainedCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedPercentage)
				this.educationDetailsForm.form.controls.obtainedPercentage.reset();
		}
		this.qualId = qualId
		if (this.qualId == 7 || this.qualId == 8) {
			this.gradingId = 10543;
			this.totalMarksGpaDisplayName = 'Obtained Marks'
			this.totalMarksGpaPlaceHolder = 'Enter Obtained Marks'
		} else {
			this.gradingId = undefined
		}
	}

	public async getSelectedCountryId(countryId) {
		if (countryId) {
			this.educationDetailsData.employmentCountryId = countryId;

			if (this.educationDetailsForm.form.controls.sectorCode)
				this.educationDetailsForm.form.controls.sectorCode.reset();

			this.getCitiesByCountry(countryId);
		}
	}

	public async getSelectedSectorId(sectorId) {
		if (sectorId) {
			this.educationDetailsData.sectorCode = sectorId;

			if (this.educationDetailsForm.form.controls.categoryCodeId)
				this.educationDetailsForm.form.controls.categoryCodeId.reset();
		}
	}

	public async getSelectedCategoryId(categoryId) {
		if (categoryId) {
			this.educationDetailsData.categoryCodeId = categoryId;

			if (this.educationDetailsForm.form.controls.employerId)
				this.educationDetailsForm.form.controls.employerId.reset();

			await this.getUniversityListByCountryAndSector(categoryId);
		}
	}

	public getUniversityListByCountryAndSector(categoryId) {
		return new Promise((resolve, reject) => {
			if (categoryId != undefined) {
				if (this.educationDetailsData && this.educationDetailsData.employerTypeCode == HEC_CONSTANTS.EMP_ORGANIZATION_TYPE.Academic) {
					this.educationDetailsService.getUniversityListByCountryAndSector(this.educationDetailsData.employmentCountryId, this.educationDetailsData.sectorCode, categoryId).subscribe(
						(res: HecResponse) => {
							if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
								this.dropdownList.empNameList = res.data;
								resolve(this.dropdownList.empNameList);
								this.cdr.detectChanges();
							}
						},
						(err) => {

						}
					)
				}
				else {
					this.educationDetailsService.getOrganizationListByCountryAndSector(this.educationDetailsData.employmentCountryId, this.educationDetailsData.sectorCode, categoryId).subscribe(
						(res: HecResponse) => {
							if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
								for (let i = 0; i < res.data.length; i++) {
									res.data[i]["value"] = res.data[i]["id"];
									res.data[i]["label"] = res.data[i]["organizationName"];
								}
								this.dropdownList.empNameList = res.data;
								resolve(this.dropdownList.empNameList);
								this.cdr.detectChanges();
							}
						},
						(err) => {

						}
					)
				}
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getGradingType(gradingId) {
		this.gradingId = gradingId;
		if (gradingId == 10541) {
			this.totalMarksGpaDisplayName = 'Obtained CGPA'
			this.totalMarksGpaPlaceHolder = 'Enter Obtained CGPA'
		} else if (gradingId == 10543) {
			this.totalMarksGpaDisplayName = 'Obtained Marks'
			this.totalMarksGpaPlaceHolder = 'Enter Obtained Marks'

		}
	}

	public getSelectedGpaValue(gpaValue, type?) {
		this.maxGpaValue = gpaValue;
		if (type == undefined) {
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.reset()
		}
		this.cdr.detectChanges();
	}

	public getObtainedMarksGpaValue(event) {
		if (+event.target.value > +this.maxGpaValue) {
			this.isMarksCorrect = false;
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.setErrors({ max: true })
		} else {
			this.isMarksCorrect = true;
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.setErrors(null)

		}
	}

	public getDateValue(date, field, eduId?, formtype?) {
		if (field == 'end' && String(date) == String(this.startDate)) {
			this.greaterThanOrEqualErrorMessage = "End date should be greater than Start date";
			this.cdr.detectChanges();
		}
		if (field == 'start') {
			this.startDate = new Date(date);
			this.cdr.detectChanges();
		}

		if (field == 'start' && formtype == undefined) {
			this.educationDetailsForm.form.controls.endDate.reset();
		}
		if (this.formViewType != 'view') {
			for (let i = 0; i < this.educationDetailGridData.length; i++) {
				let check = new Date(date).getFullYear() + '-' + new Date(date).getMonth() + '-' + new Date(date).getDate()
				let from = new Date(this.educationDetailGridData[i].startDate).getFullYear() + '-' + new Date(this.educationDetailGridData[i].startDate).getMonth() + '-' + new Date(this.educationDetailGridData[i].startDate).getDate()
				let to = new Date(this.educationDetailGridData[i].endDate).getFullYear() + '-' + new Date(this.educationDetailGridData[i].endDate).getMonth() + '-' + new Date(this.educationDetailGridData[i].endDate).getDate()
				if (check > from && check < to && eduId != this.educationDetailGridData[i].employmentId) {
					this.equalToErrorMessage = this.educationDetailGridData[i].designation;
					this.alertBoxMsg('Your current date selection overlaps the duration of your ' + this.equalToErrorMessage + ' employment. Please change your date selection.')
					this.isEduAlertVisible = true;
					this.cdr.detectChanges();
					if (field == 'start') {
						this.educationDetailsForm.form.controls.startDate.setErrors({ equalTo: true });
						if (this.formViewType == 'edit') {
							this.markFormsTouched(this.educationDetailsForm)
						}
						this.cdr.detectChanges();
						return;
					} else if (field == 'end') {
						this.endDate = date;
						this.educationDetailsForm.form.controls.endDate.setErrors({ equalTo: true });
						return;
					}
				} else if (field == 'start' && (new Date(this.startDate) < new Date(this.educationDetailGridData[i].startDate) &&
					new Date(this.educationDetailGridData[i].endDate) < new Date(this.endDate)) && eduId != this.educationDetailGridData[i].employmentId) {
					this.educationDetailsForm.form.controls.endDate.setErrors({ equalTo: true });
					this.equalToErrorMessage = this.educationDetailGridData[i].designation;
					this.alertBoxMsg('Your current date selection overlaps the duration of your ' + this.equalToErrorMessage + ' employment. Please change your date selection.')
					this.isEduAlertVisible = true;
					return;

				}
				else if (field == 'end' && (new Date(this.startDate) < new Date(this.educationDetailGridData[i].startDate) &&
					new Date(this.educationDetailGridData[i].endDate) < new Date(date)) && eduId != this.educationDetailGridData[i].employmentId) {
					this.educationDetailsForm.form.controls.endDate.setErrors({ equalTo: true });
					this.equalToErrorMessage = this.educationDetailGridData[i].designation;
					this.alertBoxMsg('Your current date selection overlaps the duration of your ' + this.equalToErrorMessage + ' employment. Please change your date selection.')
					this.isEduAlertVisible = true;
					return;
				}
				else {
					this.isEduAlertVisible = false;
					this.cdr.detectChanges();
				}
			}
		}
	}

	public getResearchWork(event) {
		this.isResearchWork = event;
	}

	public cancelContact() {
		this.cancelEducation.emit('cancel')
	}

	setStep(index: number) {
		this.step = index;
	}

	nextStep() {
		this.step++;
	}

	prevStep() {
		this.step--;
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(f): boolean {
		if (f.status === 'VALID') {
			return true;
		}
	}

	public getIncompleteEduStatus(event, type?) {
		this.isEducationInComplete = event;
		this.isCurrentlyEnrolled = false;
		if (type) {
			this.educationDetailsData.currentEnrolmentInd = undefined
			this.educationDetailsForm.form.controls.currentEnrolmentInd.reset();
		}
	}

	public getCurrentlyEnrolledStatus(event, type?) {
		this.isCurrentlyEnrolled = event;
		if ((event && type != undefined) || (!event && type != undefined)) {
			this.educationDetailsForm.form.controls.endDate.reset();
			if (this.educationDetailsForm.form.controls.totalCGPAMarks)
				this.educationDetailsForm.form.controls.totalCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedCGPAMarks)
				this.educationDetailsForm.form.controls.obtainedCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedPercentage)
				this.educationDetailsForm.form.controls.obtainedPercentage.reset();

		}
	}

	public saveEducation() {
		this.markFormsTouched(this.educationDetailsForm)
		if (this.validate(this.educationDetailsForm)) {
			localStorage.setItem('name', encrypt(this.educationDetailsForm.value.empName))
			this.loader = true;
			this.loaderService.setValue(this.loader)
			let payload = this.educationDetailsForm.value;
			payload.current = this.educationDetailsData.current;
			if (this.educationDetailsData.employmentId) payload.employmentId = this.educationDetailsData.employmentId;
			payload.activeIndicator = true;
			payload.startDate = new Date(payload.startDate).getTime();
			payload.endDate = (payload.current) ? null : new Date(payload.endDate).getTime();
			if (payload.employerTypeCode === HEC_CONSTANTS.EMP_ORGANIZATION_TYPE.Academic) {
				payload.universityId = payload.employerId;
			} else {
				payload.organizationId = payload.employerId;
			}
			delete payload["searchCtrl"];
			delete payload["employerId"];
			if (!payload["current"]) {
				payload["current"] = false;
			} else {
				payload["current"] = true;
			}

			this.educationDetailsService.saveOrUpdateEmployment(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.isAlertVisible = false;
						let emitData = {
							statusCode: res.statusCode,
							id: res.data.employmentId
						}
						this.empUpdated.emit(emitData);
					} else {
						this.loader = false;
						this.loaderService.setValue(this.loader)
						this.isAlertVisible = true;
						this.alertBoxMsg('Error in saving employment form');
						this.cdr.detectChanges();
						setTimeout(() => {
							this.isAlertVisible = false;
							this.cdr.detectChanges();
						}, 3000);
					}
				},
				(err) => {
					this.isAlertVisible = true;
					this.alertBoxMsg('Error in saving employment form');
					this.loader = false;
					this.loaderService.setValue(this.loader)
					this.cdr.detectChanges();
					setTimeout(() => {
						this.isAlertVisible = false;
						this.cdr.detectChanges();
					}, 3000);
				}
			)
		}
		else {
			if (this.findInvalidControls().length > 0) {
				let fields = this.findInvalidControls().join(', ')
				this.alertBoxMsg('Please fill all the mandatory fields with valid data');
				this.isAlertVisible = true;
				this.cdr.detectChanges()
			}
		}
	}

	public findInvalidControls() {
		const invalid = [];
		const controls = this.educationDetailsForm.form.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	}

	private alertBoxMsg(message, alertType?) {
		if (alertType == 'success') {
			this.alertClass = 'alert alert-solid-success alert-bold fade show kt-margin-t-20 kt-margin-b-40';
			this.alertIcon = 'fa fa-check-circle'
		} else if (alertType == 'warning') {
			this.alertClass = 'alert alert-solid-warning alert-bold fade show kt-margin-t-20 kt-margin-b-40';
			this.alertIcon = 'fas fa-exclamation-circle'
		} else {
			this.alertClass = 'alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40';
			this.alertIcon = 'fa fa-exclamation-triangle'
		}
		this.alertMsgValue = message;
	}

	employerChanged = value => {
		this.educationDetailsData.employerTypeCode = value;
	}

	employmentCountryChanged = (countryId) => {
		this.getCitiesByCountry(countryId);
	}

	employmentCityChanged = (cityId) => {
		this.educationDetailsData.employmentCityId = cityId;
	}

	showEmploymentType = (sectorCode, employerTypeCode) => {
		return sectorCode == HEC_CONSTANTS.EMP_A_SECTOR.Public && employerTypeCode == HEC_CONSTANTS.EMP_ORGANIZATION_TYPE.Academic;
	}

	showHeadOffice = (sectorCode, employerTypeCode) => {
		return sectorCode == HEC_CONSTANTS.EMP_A_SECTOR.Private && employerTypeCode == HEC_CONSTANTS.EMP_ORGANIZATION_TYPE.Academic;
	}

	showEmpSubType = sectorCode => {
		return sectorCode === HEC_CONSTANTS.EMP_P_SECTOR.Private || sectorCode == HEC_CONSTANTS.EMP_A_SECTOR.Private;
	}

	showScaleEquivalent = sectorCode => {
		return sectorCode == HEC_CONSTANTS.EMP_P_SECTOR.Public || sectorCode == HEC_CONSTANTS.EMP_A_SECTOR.Public;
	}

	setEmployerName = id => this.educationDetailsData.employerId = id;
	changedCurrentEmployment = async(id) => {

		let currentEmp;
		if(id) currentEmp = await this.educationDetailGridData.filter(emp => emp.current);

		this.educationDetailsData.current = id;

		if (id && currentEmp && currentEmp.length > 0) {
			this.isAlertVisible = true;
			this.alertBoxMsg('You cannot have multiple current employments.');
			this.cdr.detectChanges();

			setTimeout(() => {
				this.isAlertVisible = false;
				this.educationDetailsData.current = false;
				this.cdr.detectChanges();
			}, 1000);
		}
		else {
			if (id) {
				this.educationDetailsData.endDate = null;
			}
		}
	};

	getCategoriesDropdown = () => this.educationDetailsData && this.educationDetailsData.employerTypeCode == HEC_CONSTANTS.EMP_ORGANIZATION_TYPE.Academic ? this.empFormDropdowns.category : this.empFormDropdowns.organizationList;
	

	getSectorsList() {		
		let acronym = localStorage.getItem('processAcronym')
		if (acronym == 'FDP') {
			this.empFormDropdowns.sectorList = this.empFormDropdowns.sectorList.filter(item => !(item.label === "Private Sector" && item.value === 10252));
			this.empFormDropdowns.universitySectorList = this.empFormDropdowns.universitySectorList.filter(item => !(item.label === "Private Sector" && item.value === 101));
		}

		return this.educationDetailsData &&
			this.educationDetailsData.employerTypeCode == HEC_CONSTANTS.EMP_ORGANIZATION_TYPE.Academic ?
			this.empFormDropdowns.universitySectorList : this.empFormDropdowns.sectorList;
	}

	getCareerLevelList(experience) {
		if (this.educationDetailsData && this.educationDetailsData.employerTypeCode == HEC_CONSTANTS.EMP_ORGANIZATION_TYPE.Academic) {
			if (experience == HEC_CONSTANTS.EMP_TEACHING_EXP.Teaching) {
				return this.empFormDropdowns.exprienceTeachingCareerLevel;
			} else if (experience == HEC_CONSTANTS.EMP_TEACHING_EXP.NonTeaching) {
				return this.empFormDropdowns.exprienceNonTeachingCareerLevel;
			} else if (experience == HEC_CONSTANTS.EMP_TEACHING_EXP.Researcher) {
				return this.empFormDropdowns.exprienceResearcherCareerLevel;
			}
		}
		return this.empFormDropdowns.careerLevelList;
	}

	experienceTypeChanged(e) {
		this.educationDetailsData.teachingExperienceTypeCode = e
	}
}
